<template lang="pug">
span.root
	aside
		input(type="checkbox" :id="data.id" v-model="model")
		label(:for="data.id") {{ data.value }}

</template>

<script>
export default {
	name: "CaroFilterCheckbox",
	props: {
		data: Object,
		setFilterValue: Function,
		// executeSearch: Function
	},
	data() {
		return {};
	},
	computed: {
		model: {
			get() {
				return this.data.selected;
			},
			set(value) {
				this.setFilterValue(this.data, value);
			},
		},
	},
};
</script>


<style lang="scss" scoped>
span.root {
	display: contents;
}
aside {
	padding-bottom: .25rem;
}
label {
	color: #131515;
	padding-left: .5rem;
}
</style>
